import { empowermentSystem } from '@/mocks/aboutData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function EmpowermentSystem() {
  return (
    <section className="relative bg-brand-deep py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]">
        <img
          src={readdy('empower-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-gold text-sm tracking-widest mb-3 font-medium">赋能体系</p>
              <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight">
                四化赋能体系
              </h2>
              <p className="text-white/40 text-sm mt-3 max-w-xl mx-auto">
                以系统化能力为每一家门店提供坚实后盾
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {empowermentSystem.map((item, i) => (
              <ScrollReveal key={item.id} variant="fade-up" delay={i * 120}>
                <div className="group bg-white/5 backdrop-blur-sm rounded-2xl p-6 md:p-7 border border-white/10 hover:border-brand-gold/40 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-gold/15 text-brand-gold mb-5 group-hover:bg-brand-gold/25 transition-colors duration-300">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <p className="text-white/30 text-[10px] tracking-[0.2em] mb-2 font-medium uppercase">
                    {item.subtitle}
                  </p>
                  <h3 className="text-lg font-semibold text-white mb-3">{item.title}</h3>
                  <p className="text-white/50 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal variant="fade-up" delay={300}>
            <div className="mt-12 flex justify-center">
              <div className="flex flex-wrap items-center gap-4 md:gap-8 bg-white/5 rounded-full px-8 py-4 border border-white/10">
                {empowermentSystem.map((item, index) => (
                  <div key={item.id} className="flex items-center gap-2">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-gold/20 text-brand-gold text-xs font-bold">
                      {index + 1}
                    </span>
                    <span className="text-white/60 text-sm whitespace-nowrap">{item.title}</span>
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}